import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * `/accept-invitation?token=…` is the link the old invitation emails carried. That flow, with
 * its own registration form, is gone: an invitation is answered at `/invitations/<token>`,
 * where the invitee signs in (creating the account through Keycloak if need be) and accepts
 * or declines. This route only forwards, so mail already in someone's inbox keeps working.
 */
const AcceptInvitation = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  return (
    <Navigate
      to={token ? `/invitations/${encodeURIComponent(token)}` : '/login'}
      replace
    />
  );
};

export default AcceptInvitation;
